import { render, staticRenderFns } from "./Atablebar.vue?vue&type=template&id=b9667650&scoped=true"
import script from "./Atablebar.vue?vue&type=script&lang=js"
export * from "./Atablebar.vue?vue&type=script&lang=js"
import style0 from "./Atablebar.vue?vue&type=style&index=0&id=b9667650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9667650",
  null
  
)

export default component.exports